module.exports = __webpack_public_path__ + "img/2015033.b21bee50.svg";